import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

import de from 'vuetify/lib/locale/de'

export default new Vuetify({
  lang: {
    locales: { de },
    current: 'de',
  },
  theme: {
    themes: {
      light: {
        primary: '#010F30',
        secondary: '#254169',
        Rundbahn: '#47A3FF',
        Stabhochsprung: '#FFD848',
        Hauptfeld: '#FFA048',
        Weitsprung: '#FF4244',
        Hochsprung: '#CF45FF'
      },
    },
  },
})
